import React from "react"
import { Navigate } from "react-router-dom"

import UserProfile from "../pages/Authentication/UserProfile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import ChangePassword from "../pages/Authentication/ChangePassword"
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

import TaskMaster from "../pages/Task/list"
import AssignmentMaster from "../pages/Assessment/list"
import QuizMaster from "../pages/Quiz/list"
import QuizQuestions from "../pages/quiz_questions/list"
import AgeGroupMaster from "../pages/Age Group/list"
import CMSContent from "../pages/CMS Content/list"
import Privacy from "../pages/Privacy/list"
import Terms from "../pages/Terms/list"
import Users from "../pages/Users/list"
import Merchant from "../pages/Merchant/list"
import HomePageImage from "../pages/HomePage Image/list"
import Kids from "../pages/Kids/list"
import School from "../pages/School/list"
import Teacher from "../pages/Teachers-list/list"
import QuizSubQuestions from "../pages/quiz_sub_questions/list"

// Redirect component for default route
const RedirectToTask = () => <Navigate to="/task" replace />

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/task", component: TaskMaster },
  { path: "/age-group", component: AgeGroupMaster },
  { path: "/assessment", component: AssignmentMaster },
  { path: "/profile", component: UserProfile },
  { path: "/quiz", component: QuizMaster },
  { path: "/cms-content", component: CMSContent },
  { path: "/quiz-questions/:id", component: QuizQuestions },
  { path: "/quiz-sub-questions/:id", component: QuizSubQuestions },
  { path: "/quiz-sub-questions", component: QuizSubQuestions },
  { path: "/change-password", component: ChangePassword },
  { path: "/users", component: Users },
  { path: "/merchant", component: Merchant },
  { path: "/homepageimage", component: HomePageImage },
  { path: "/kids", component: Kids },
  { path: "/schools-list", component: School },
  { path: "/Teachers-list", component: Teacher },

  {
    path: "/",
    component: RedirectToTask,
  },
]

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/privacy", component: Privacy },
  { path: "/terms", component: Terms },
  { path: "/forgot-password", component: ForgetPasswordPage },
]

export { authProtectedRoutes, publicRoutes }
